import { useState, useEffect, useRef } from 'react';
import { IonLabel, IonSegment, IonSegmentButton } from '@ionic/react';
import { Storage } from '@capacitor/storage';
import Flight from './Flight';
import Hotel from './Hotel';
import FlightHotel from './FlightHotel';
import Loading from '../Loading';
import './Form.css';
const Form = () => {
    const didGetJson = useRef(false);
    const [state, setState] = useState({
        segValue: 'flight',
        flightClass: 'active',
        hotelClass: '',
        flightData: {} as any,
        hotelData: {} as any,
        flightHotelData: {} as any
    });
    useEffect(() => {
        if (!didGetJson.current) {
            const getFlightJson = async () => {
                const { value } = await Storage.get({ key: 'flightJson' });
                if (value !== null) {
                    const objectValue = JSON.parse(value);
                    let myItemValue = {
                        isJalali: objectValue.other.isJalali === true ? 'true' : 'false',
                        dates: [objectValue.routes[0].dates.departure, objectValue.routes[0].dates.arrival],
                        datesJalali: [objectValue.routes[0].dates.departureJalali, objectValue.routes[0].dates.arrivalJalali]
                    }
                    setState({ ...state, segValue: 'flight', flightData: myItemValue });
                } else {
                    const getHotelJson = async () => {
                        const { value } = await Storage.get({ key: 'hotelJson' });
                        if (value !== null) {
                            const objectValue = JSON.parse(value);
                            let myItemValue = objectValue[0];
                            setState({ ...state, segValue: 'hotel', hotelData: myItemValue });
                        } else {
                            const getFlightHotelJson = async () => {
                                const { value } = await Storage.get({ key: 'flightHotelJson' });
                                if (value !== null) {
                                    const objectValue = JSON.parse(value);
                                    setState({ ...state, segValue: 'flight_hotel', flightHotelData: objectValue });
                                } else {
                                    setState({ ...state, segValue: 'flight' });
                                }
                            };
                            getFlightHotelJson();
                        }
                    };
                    getHotelJson();
                }
            };
            getFlightJson();
            didGetJson.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onSegmentChange = (e: any) => {
        setState({ ...state, segValue: e });
    }
    return (
        <div className="form-container">
            {state.segValue &&
                <>
                    <IonSegment className="form-swap-segment" onIonChange={e => onSegmentChange(e.detail.value!)} value={state.segValue}>
                        <IonSegmentButton value="flight">
                            <IonLabel>پرواز</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="hotel">
                            <IonLabel>هتل</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="flight_hotel">
                            <IonLabel>پرواز + هتل | تور آنلاین </IonLabel>
                        </IonSegmentButton>
                    </IonSegment>
                </>
            }
            {state.segValue === 'flight' ?
                <Flight data={state.flightData} />
                :
                state.segValue === 'hotel' ?
                    <Hotel data={state.hotelData} />
                    :
                    state.segValue === 'flight_hotel' ?
                        <FlightHotel />
                        :
                        <Loading />
            }
        </div>
    );
}
export default Form;